import { CouponCodeException } from '@/domain/stripe/couponCode/repository/contract/exception/CouponCodeException'

export class InvalidOrUsedCouponCodeException extends CouponCodeException {
}
